if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

onSlideChanged(event) {
  if (event.detail && event.detail.currentElement) {
    const thumbnail = this.elements.thumbnails.querySelector(
      `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
    );
    if (thumbnail) {
      this.setActiveThumbnail(thumbnail);
    }
  } else {
    console.warn("Event detail or currentElement is missing");
  }
}

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
document.addEventListener("DOMContentLoaded", function() {
  let initialScrollPos = window.scrollY;
  
  // Debugging: Initial log
  console.log('DOMContentLoaded event fired.');
  
  // Store the initial setup of all elements
  const initialSetup = {};
  const selectors = '.product__media-item, .thumbnail-list__item, .product-media-modal__content img';
  const allElements = document.querySelectorAll(selectors);
  
  allElements.forEach((element, index) => {
    initialSetup[index] = element.style.display;
  });

  const initialSelectedRadio = document.querySelector('input[name="Color"]:checked');
  if (initialSelectedRadio) {
    hideAllLIsExcept(initialSelectedRadio.value);
  }
  
  // Debugging: Log initial selected radio
  console.log('Initial selected radio:', initialSelectedRadio ? initialSelectedRadio.value : 'None');

  const radios = document.querySelectorAll('input[name="Color"]');
  if (radios.length === 0) {
    document.body.classList.add('noColorVariants');
    return; // Exit early if no color variants
  }
  radios.forEach((radio) => {
    radio.addEventListener("change", function() {
      
      // Debugging: Log changes
      console.log(`Radio changed to: ${this.value}, Checked status: ${this.checked}`);
      
      const newScrollPos = window.scrollY;

      if (this.value.toLowerCase() === "orange") {
        console.log('Special case: Orange selected'); // Debugging: Special log for 'Orange'
        restoreInitialSetup(initialSetup);
      } else {
        hideAllLIsExcept(this.value);
      }

      window.scrollTo(0, initialScrollPos);
      initialScrollPos = newScrollPos;
    });
  });

  const firstVariant = document.getElementById('template--18114626978059__main-1-0');
  
  firstVariant.addEventListener('click', function() {
    if(!this.checked) {
      // Debugging: Log first variant click
      console.log('First variant clicked but not checked.');
      
      // Remove URL variables and reload
      window.location.href = window.location.protocol + "//" + window.location.host + window.location.pathname;
    }
  });
});

function hideAllLIsExcept(color = "") {
  const selectors = '.product__media-item, .thumbnail-list__item, .product-media-modal__content img';
  const allElements = document.querySelectorAll(selectors);
  
  allElements.forEach((element) => {
    const img = element.querySelector('img') ? element.querySelector('img') : element;
    if (img && img.alt.toLowerCase() === color.toLowerCase()) {
      element.style.display = 'block';
    } else {
      element.style.display = 'none';
    }
  });
}

function restoreInitialSetup(initialSetup) {
  const selectors = '.product__media-item, .thumbnail-list__item, .product-media-modal__content img';
  const allElements = document.querySelectorAll(selectors);
  allElements.forEach((element, index) => {
    element.style.display = initialSetup[index] || 'none';
  });
}



}
